import _ from 'lodash';
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { CertificationCategory } from 'util/resources';

export const fetchCertificationCategories = createAsyncThunk(
  'certificationCategories/fetch',
  async (_args, thunkAPI) => {
    const state = thunkAPI.getState();
    const geographyId =
      state.employer.employer.geographyId || state.currentUserProfile.geography.id;
    const options = await CertificationCategory.where({ geographyId })
      .includes('geography', 'certification_options')
      .all();

    const userProfileRegisterableGeos = options
      .all()
      .filter((opt) => opt.geography()?.userProfileRegisterable || opt.categoryType === 'cda');
    return userProfileRegisterableGeos;
  },
);

export const selectCategoryById = createSelector(
  (state) => state.certificationCategories.items,
  (_state, categoryId) => categoryId,
  (items, categoryId) => items.find((item) => item.id === categoryId),
);

export const selectCategoryByOptionId = createSelector(
  (state) => state.certificationCategories.items,
  (_state, optionId) => optionId,
  (categories, optionId) =>
    categories.find((category) =>
      category
        .certificationOptions()
        .toArray()
        .find((option) => option.id == optionId),
    ),
);

export const selectStateCertificationOptions = createSelector(
  (state) =>
    state.certificationCategories.items.filter(
      ({ categoryType }) => categoryType === 'state_certification',
    ),
  (categories) => categories.flatMap((category) => category.certificationOptions().toArray()),
);

export const selectStateCertificationCategories = createSelector(
  (state) => state.certificationCategories.items,
  (categories) =>
    _.sortBy(
      categories.filter(({ categoryType }) => categoryType === 'state_certification'),
      ['title'],
    ),
);

const slice = createSlice({
  name: 'certificationCategories',
  initialState: {
    items: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCertificationCategories.rejected, (_state, action) => {
      console.error('Error running request', action);
    });
    builder.addCase(fetchCertificationCategories.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  },
});

export default slice;
